export const metaInit = (next, config) => {
  if (!config.meta) {
    config.meta = {};
  }

  return next();
};
